import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteAtmServiceProvider = ({ atmServiceProviderId }: { atmServiceProviderId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/AtmServiceProviders/DeleteAtmServiceProvider/${atmServiceProviderId}`);
};

type QueryFnType = typeof deleteAtmServiceProvider;

type UseDeleteAtmServiceProviderOptions = {
  atmServiceProviderId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteAtmServiceProvider = ({ config }: UseDeleteAtmServiceProviderOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllAtmServiceProviders"]);
      addNotification(`Το ATM Service Provider Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteAtmServiceProvider,
  });
};
